/* @flow */
import React from 'react'
import { Translate, I18n } from 'react-redux-i18n'
// import { DateRangePicker } from 'react-dates'
import Autocomplete from 'react-autocomplete'
import Select from 'react-select'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch'
import moment from 'moment'
import _ from 'lodash'

import './style.css'
import Divider from '../Divider'
import { divingExps } from '../../configs/constants'
import { getObjectByStringPath } from '../../libs/utility'

// const CalendarIcon = () => <i className="icon icon-calendar">
//   <span className="path1"></span>
//   <span className="path2"></span>
//   <span className="path3"></span>
//   <span className="path4"></span>
//   <span className="path5"></span>
// </i>

class CompoundInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startDate: moment(),
      endDate: moment().add(1, 'd'),
      focused: props.focused,
      searchText: '',
      divingExp: 0,
    }
  }

  submit = () => {
    if (this.props.submit) {
      const { selected, startDate, endDate, divingExp } = this.state
      this.props.submit((selected && selected.name), startDate, endDate, divingExp)
    }
  }

  render() {
    const { displayFields, submitText, simpleSearch } = this.props
    const { divingExp } = this.state
    const divingExpList = _.map(divingExps, (exp) => ({
      ...exp,
      label: I18n.t(exp.label),
    }))
    return <div className="search-wrapper">
      <div className="input-container">
        <Autocomplete
          menuStyle={{
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '90%',
            position: 'fixed',
            top: 130,
            overflow: 'auto',
            maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
            zIndex: 12,
            marginLeft: 0,
          }}
          getItemValue={item => displayFields.split(',').map(field => getObjectByStringPath(item, field)).join(' ')}
          items={this.props.dataList}
          shouldItemRender={(item, value) =>
            _.some(displayFields.split(',').map(field => {
              const itemField = getObjectByStringPath(item, field)
              return itemField.toLowerCase().indexOf(value.toLowerCase()) > -1
            }), Boolean)
          }
          renderItem={(item, isHighlighted) =>
            <div key={item.id} className={'item ' + (isHighlighted && 'item-selected')}>
              { displayFields.split(',').map(field => getObjectByStringPath(item, field)).join(' ')
              }
            </div>
          }
          value={this.state.searchText}
          onChange={ (e) => this.setState({ searchText: e.target.value }) }
          onSelect={(value, item) => this.setState({ selected: item, searchText: value })}
          inputProps={{ placeholder: this.props.placeholder }}
        />
        { simpleSearch && <FontAwesomeIcon size="lg" icon={faSearch} /> }
      </div>
      {/* <Divider className="border" width='100%' height={1} />
      <div className="input-container">
        <DateRangePicker
          customInputIcon={<CalendarIcon />}
          numberOfMonths={1}
          displayFormat="YYYY/MM/DD"
          startDate={this.state.startDate} // momentPropTypes.momentObj or null
          startDateId="activity_start_date"
          endDate={this.state.endDate} // momentPropTypes.momentObj or null
          endDateId="activity_end_date"          
          onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired
          focusedInput={this.state.focused} // PropTypes.bool
          onFocusChange={(focused) => this.setState({ focused })} // PropTypes.func.isRequired
        />
      </div> */}
      {/* <Divider className="border" width='100%' height={1} />      
      <div className="compound-container">
        <div className="input-container">
          <i className="icon icon-diving" />
          <Translate className="label" value="divingExperience" />
          <Select
            name="fDivingExp"
            value={_.find(divingExpList, (option) => option.value === divingExp)}
            onChange={(selected) => this.setState({ divingExp: selected.value })}
            options={divingExpList}
            searchable={false}
            clearable={false} />
        </div>
        <div className="submit" onClick={this.submit}><Translate value={submitText || 'findActivity'} /></div>
      </div> */}
    </div>
  }
}

export default CompoundInput


// WEBPACK FOOTER //
// ./src/components/CompoundInput/index.js